import React, { useEffect } from 'react';

type OKomModalProps = {
  open: boolean;
  onClose: () => void;
  children?: React.ReactNode;
  /** Optional aria-label for the dialog (use when no visible heading). */
  ariaLabel?: string;
  /** Optional id of the element that titles the dialog (preferred over ariaLabel). */
  labelledBy?: string;
  /** Hide the built-in close button (e.g. for blocking confirms). Default false. */
  hideCloseButton?: boolean;
};

const OKomModal: React.FC<OKomModalProps> = ({
  open,
  onClose,
  children,
  ariaLabel,
  labelledBy,
  hideCloseButton = false,
}) => {
  useEffect(() => {
    if (!open) return;
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open) return null;

  const handleOverlayClick = (e: React.MouseEvent<HTMLDivElement>) => {
    if (e.target === e.currentTarget) onClose();
  };

  return (
    <div
      className="ods-modal ods-modal--open"
      role="dialog"
      aria-modal="true"
      aria-label={labelledBy ? undefined : ariaLabel}
      aria-labelledby={labelledBy}
      onClick={handleOverlayClick}
    >
      <div className="ods-modal__popup">
        {!hideCloseButton && (
          <div className="ods-modal__button">
            <div></div>
            <button
              type="button"
              className="ods-button ods-button--circle ods-button--yellow"
              aria-label="Lukk"
              onClick={onClose}
            >
              <span className="ods-button__icon ods-icon--close" aria-hidden="true"></span>
            </button>
          </div>
        )}
        <div className="ods-modal__content">{children}</div>
      </div>
    </div>
  );
};

export default OKomModal;
